import React, { SVGProps } from "react";

export default function SupLinkExternal(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 3H6C4.34315 3 3 4.34315 3 6V14C3 15.6569 4.34315 17 6 17H14C15.6569 17 17 15.6569 17 14V10H18V14C18 16.2091 16.2091 18 14 18H6C3.79086 18 2 16.2091 2 14V6C2 3.79086 3.79086 2 6 2H10V3Z"
        fill="currentColor"
      />
      <path d="M16.4338 3H12V2H18V8H17V3.84806L10.3248 10.5233L9.61768 9.81615L16.4338 3Z" fill="currentColor" />
    </svg>
  );
}
